<template>
  <div class="wiki-detail-footer">
    <div class="article-footer">
      <div class="tag">创建于：{{ detail.created_at | dateFromNow }}</div>
      <div class="tag" style="cursor: pointer;" @click="onShowReport">
        <i class="el-icon-warning-outline" style="margin-right: 3px;"></i>
        举报
      </div>
    </div>
    <div class="article-options">
      <div class="option-item like-item" @click="onLike">
        <i :class="['like-icon', detail.is_like ? 'is-active' : '']"></i>
        <span>{{ detail.like_count }}</span>
      </div>
      <div class="option-item" @click="onFavorite">
        <i :class="['wiki-icon', detail.is_favorite ? 'wiki-article-star-active' : 'wiki-article-star']"></i>
        <span>{{ detail.favorite_count }}</span>
      </div>
      <div class="option-item" @click="onShare">
        <i class="wiki-icon wiki-icon-share"></i>
        <span>分享</span>
      </div>
    </div>
    <!-- 侧边栏 -->
    <div class="aside-box">
      <div class="item" @click="onLike">
        <i :class="['wiki-icon', detail.is_like ? 'wiki-icon-detail-like-active' : 'wiki-icon-detail-like']"></i>
        <span>{{ formatCount(detail.like_count) }}</span>
      </div>
      <div class="item" @click="onComment">
        <i :class="['wiki-icon', 'wiki-icon-detail-comment']"></i>
        <span>{{ formatCount(detail.comment_count) }}</span>
      </div>
      <div class="item" @click="onFavorite">
        <i
          :class="['wiki-icon', detail.is_favorite ? 'wiki-icon-detail-favorite-active' : 'wiki-icon-detail-favorite']"
        ></i>
        <span>{{ formatCount(detail.favorite_count) }}</span>
      </div>
      <div class="item" @click="onShare">
        <i :class="['wiki-icon', 'wiki-icon-detail-share']"></i>
        <span>分享</span>
      </div>
    </div>
    <!-- 举报弹框 -->
    <report-dialog ref="report" />
  </div>
</template>

<script>
import Clipboard from "clipboard";
// api
import { apiContentLike } from "@/api/contentApi";
import { apiUserAddFavorite } from "@/api/userApi";
// components
import ReportDialog from "../../components/reportDialog";

export default {
  name: "DetailOther",
  components: {
    ReportDialog
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  methods: {
    // 打开举报弹框
    onShowReport() {
      this.$refs.report.id = this.detail.id;
      this.$refs.report.type = 1;
      this.$refs.report.isShow = true;
    },
    // 点赞
    onLike() {
      // if (!this.isLogin()) {
      //   return false;
      // }
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    },
    // 打赏用户
    onReward() {
      this.$message({
        type: "info",
        message: "功能暂未开放"
      });
    },
    // 收藏文章
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";

      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    onComment() {
      window.scrollTo({
        top: document.querySelector(".wiki-detail-comment").offsetTop,
        behavior: "smooth"
      });
    },
    formatCount(count) {
      if (count >= 1000 && count < 10000) {
        return Math.floor(count / 1000) + "k+";
      } else if (count > 10000) {
        return Math.floor(count / 10000) + "w+";
      }
      return count;
    }
  }
};
</script>

<style lang="less" scoped>
.wiki-detail-footer {
  .article-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 36px;
    .tag {
      height: 26px;
      line-height: 26px;
      color: #999;
      font-size: 12px;
    }
  }

  .article-options {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 36px;
    margin-bottom: 52px;
    .option-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      margin-right: 72px;
      border-radius: 50%;
      color: #666;
      font-size: 12px;
      background-color: #f5f5f5;
      cursor: pointer;
      i {
        margin-bottom: 4px;
        font-size: 18px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .aside-box {
    position: fixed;
    bottom: 190px;
    left: 50%;
    margin-left: 690px;
    width: 48px;
    padding: 12px 0;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item {
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 14px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.like-item {
  position: relative;
  .like-icon {
    position: absolute;
    display: inline-block;
    width: 100px;
    height: 100px;
    background: url("../../../../assets/images/like-animate.png") no-repeat;
    background-size: 2900px 100px;
    background-position: 0 -4px;
    transition: background-position 1s steps(28);
    transition-duration: 0s;
    animation: bounce;
    animation-delay: 2.5s;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    &.is-active {
      -webkit-transition-duration: 1s;
      transition-duration: 1s;
      background-position: -2800px -4px;
      animation: none;
    }
  }
  span {
    padding-top: 28px;
  }
}

@keyframes bounce {
  0%,
  6%,
  15%,
  27% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }

  12%,
  13% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }
  19% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }
  22% {
    transform: translateZ(0) scaleY(0.95);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  25% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}
</style>
